<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <h1>User Permissions</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full md:w-full md:pr-4">
                        <div class="permissions-body">
                            <ul class="list-unstyled" v-if="permissions">
                                <li v-for="(value, name) in userPermissions">
                                    <div class="checkbox">
                                        <label v-if="name == 'super'">
                                            <input type="checkbox" v-model="permissions[name]" :value="name"
                                                   @change="toggleAllFields(permissions[name])">
                                            {{ value }}
                                        </label>
                                        <label v-else>
                                            <input type="checkbox" v-model="permissions[name]" :value="name"
                                                   :disabled="permissions['super']">
                                            {{ value }}
                                        </label>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>

                        <button class="btn-primary" type="button" @click="saveForm">Save</button>
                    </div>
                </div>
            </div>
            <router-view v-slot="{ Component }">
                <transition name="drop-in" mode="in-out">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: "AccountUserPermissions",
    props: {
        userPermissions: {
            type: Object,
            default() {
                return {
                    'media-requests': 'Receive and reply to Media Requests',
                    'write-content': 'Create Press Releases',
                    'publish-content': 'Publish Press Releases',
                    'manage-profiles': 'Manage Business Profiles',
                    'manage-users': 'Manage User Accounts',
                    'manage-billing': 'Manage Billing',
                    'super': 'Administrative User - Select to activate all permissions'
                }
            }
        }
    },
    data() {
        return {
            permissions: null
        }
    },
    mounted() {
        this.setMetaTitle('User Permissions | JournoLink Control')
        this.loadData()
    },
    beforeDestroy() {
        //
    },
    methods: {
        loadData() {
            axios.get(route('users.permissions', this.$route.params.userId))
                .then(response => {
                    this.permissions = response.data.permissions
                })
                .catch(e => {
                    console.error({e})
                })
        },
        saveForm() {
            axios.put(route('users.permissions.update', {user: this.$route.params.userId}),
                {permissions: this.permissions})
                .then(response => {
                    this.$bus.$emit('alert.success', 'Permissions have been updated')
                    this.loadData()
                })
                .catch((e) => {
                    console.error({e})
                    let message = _.get(e.response.data, 'error')
                    if (message) {
                        this.$bus.$emit('alert.danger', message)
                        return
                    }
                    this.$bus.$emit('alert.danger', 'Permissions update failed')
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.setMetaTitle('View Account | JournoLink Control')
            this.$root.goBack()
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        /**
         * toggle all fields based on super user
         * @param  {boolean} value
         * @return {void}
         */
        toggleAllFields(value) {
            let self = this
            _.forEach(this.permissions, function (item, key) {
                self.permissions[key] = value
            })
        }
    }
}
</script>

<style lang="less">
.permissions-body {
    flex: 1;
    padding: 15px;

    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;

        li {
            padding: 5px 0;
        }
    }
}
</style>
